import TopNav from './topnav';
import OffCanvas from './offcanvas';
import Slider from './slider';
import Dropdown from './dropdown';

class App {
  constructor() {
    new TopNav();
    new OffCanvas();
    new Slider();
    new Dropdown();
    const btn = document.querySelector('.btn-aanmelden');
    if (btn) {
      btn.style.backgroundColor = this.generateRandomColor();
    }
  }

  generateRandomColor() {
    this.letters = '0123456789ABCDEF';
    let color = '#';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 6; i++) {
      color += this.letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
}

new App();
